<template>
  <div>
    <DropDownMenu drop-down-icon="none" class="operator-type-dropdown" :disabled="disabled" @open="setActive">
      <template v-slot:trigger>
        <button
          class="button operator-type-button"
          :class="{ 'dropdown-active': active }"
          :disabled="disabled"
          @mouseover="onUpdatedHoverState(true)"
          @mouseout="onUpdatedHoverState(false)"
        >
          <span>{{ selectedOperator }}</span>
        </button>
      </template>
      <div class="scrollable-item-list">
        <a
          :id="'operator-type-item-' + operatorType"
          class="dropdown-item"
          v-for="operatorType in getJoinOperators()"
          :key="operatorType"
          @click="selectOperator(operatorType)"
        >
          {{ operatorType }}
        </a>
      </div>
    </DropDownMenu>
  </div>
</template>

<script lang="ts" setup>
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import { OperatorType } from '@/features/contacts/models/operatorTypes';
import { PropType, ref, watch } from 'vue';

const props = defineProps({
  value: {
    type: String as PropType<OperatorType>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: 'false',
  },
});

const emit = defineEmits<{
  (e: 'updated-hover-state', hover: boolean): void;
  (e: 'updated-operator', operator: OperatorType): void;
}>();

const hovered = ref(false);
const selectedOperator = ref(OperatorType.And);
const active = ref(false);

watch(
  () => props.value,
  () => (selectedOperator.value = props.value),
  { immediate: true },
);

function getJoinOperators(): OperatorType[] {
  return [OperatorType.And, OperatorType.Or];
}

function selectOperator(type: OperatorType) {
  if (props.disabled) {
    return;
  }

  if (selectedOperator.value !== type) {
    emit('updated-operator', type);
  }
  selectedOperator.value = type;
  active.value = false;
}

function setActive(isOpen: boolean) {
  if (props.disabled) {
    return;
  }

  active.value = isOpen;
}

function onUpdatedHoverState(hover: boolean) {
  emit('updated-hover-state', hover);
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.button.operator-type-button {
  min-width: 56px;
  border-radius: 0;

  &.dropdown-active {
    background-color: #ddd;
    border: solid 1px #ddd;
  }

  &:focus:not(:active) {
    box-shadow: none;
  }

  &.disabled {
    opacity: 0.6;
    cursor: default;
  }
}

:deep(.dropdown-menu) {
  width: 100%;
  min-width: 0;
}

a.dropdown-item {
  padding-right: 0;
}
</style>
